/**
 * @generated SignedSource<<1f9be7958c076fefa017f02dfc890023>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type SignalPriority = "DEFAULT" | "HIGH" | "LOW" | "URGENT";
import { FragmentRefs } from "relay-runtime";
export type WorkspaceSignalsArchivedList_archiveSignals$data = {
  readonly archivedSignals: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly archivedAtDate: {
          readonly " $fragmentSpreads": FragmentRefs<"FormattedDate">;
        } | null;
        readonly id: string;
        readonly priority: SignalPriority;
        readonly publishedAtDate: {
          readonly " $fragmentSpreads": FragmentRefs<"FormattedDate">;
        } | null;
        readonly " $fragmentSpreads": FragmentRefs<"WorkspaceSignalListItemDescription_signal">;
      };
    }>;
  };
  readonly hasArchivedSignal: boolean;
  readonly id: string;
  readonly " $fragmentType": "WorkspaceSignalsArchivedList_archiveSignals";
};
export type WorkspaceSignalsArchivedList_archiveSignals$key = {
  readonly " $data"?: WorkspaceSignalsArchivedList_archiveSignals$data;
  readonly " $fragmentSpreads": FragmentRefs<"WorkspaceSignalsArchivedList_archiveSignals">;
};

const node: ReaderFragment = (function(){
var v0 = [
  "archivedSignals"
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "args": null,
    "kind": "FragmentSpread",
    "name": "FormattedDate"
  }
];
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "after"
    },
    {
      "kind": "RootArgument",
      "name": "first"
    },
    {
      "kind": "RootArgument",
      "name": "query"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "first",
        "cursor": "after",
        "direction": "forward",
        "path": (v0/*: any*/)
      }
    ],
    "refetch": {
      "connection": {
        "forward": {
          "count": "first",
          "cursor": "after"
        },
        "backward": null,
        "path": (v0/*: any*/)
      },
      "fragmentPathInResult": [
        "node"
      ],
      "operation": require('./WorkspaceSignalsArchivedList_WorkspaceRefetchQuery.graphql'),
      "identifierInfo": {
        "identifierField": "id",
        "identifierQueryVariableName": "id"
      }
    }
  },
  "name": "WorkspaceSignalsArchivedList_archiveSignals",
  "selections": [
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasArchivedSignal",
      "storageKey": null
    },
    {
      "alias": "archivedSignals",
      "args": [
        {
          "kind": "Variable",
          "name": "query",
          "variableName": "query"
        }
      ],
      "concreteType": "SignalWorkspaceConnection",
      "kind": "LinkedField",
      "name": "__WorkspaceSignalsArchivedList_archiveSignals_archivedSignals_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "SignalWorkspaceEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "SignalWorkspace",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v1/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "UnzonedDate",
                  "kind": "LinkedField",
                  "name": "publishedAtDate",
                  "plural": false,
                  "selections": (v2/*: any*/),
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "priority",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "UnzonedDate",
                  "kind": "LinkedField",
                  "name": "archivedAtDate",
                  "plural": false,
                  "selections": (v2/*: any*/),
                  "storageKey": null
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "WorkspaceSignalListItemDescription_signal"
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endCursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasNextPage",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Workspace",
  "abstractKey": null
};
})();

(node as any).hash = "6deb55ff99876fd7c768046c5cc4a320";

export default node;
